var exports = {
  "wx": "MobileSettingsView.module__header___U1RPTk",
  "VW": "MobileSettingsView.module__headerContent___U1RPTk",
  "pS": "MobileSettingsView.module__headerContentRelative___U1RPTk",
  "lt": "MobileSettingsView.module__bannerTextContainer___U1RPTk",
  "_M": "MobileSettingsView.module__bannerText___U1RPTk",
  "BM": "MobileSettingsView.module__bannerTextWhite___U1RPTk",
  "yp": "MobileSettingsView.module__bannerTextPrimary___U1RPTk",
  "gG": "MobileSettingsView.module__bannerActions___U1RPTk",
  "Gv": "MobileSettingsView.module__backButton___U1RPTk",
  "qd": "MobileSettingsView.module__headerTitle___U1RPTk",
  "aF": "MobileSettingsView.module__headerActionSlot___U1RPTk",
  "BJ": "MobileSettingsView.module__icon5___U1RPTk",
  "gs": "MobileSettingsView.module__scrollerContainer___U1RPTk",
  "Wy": "MobileSettingsView.module__categorySection___U1RPTk",
  "p8": "MobileSettingsView.module__categoryTitle___U1RPTk",
  "jv": "MobileSettingsView.module__categoryList___U1RPTk",
  "tl": "MobileSettingsView.module__settingsItem___U1RPTk",
  "ZF": "MobileSettingsView.module__settingsItemPressed___U1RPTk",
  "QS": "MobileSettingsView.module__settingsItemIcon___U1RPTk",
  "ec": "MobileSettingsView.module__settingsItemContent___U1RPTk",
  "CR": "MobileSettingsView.module__settingsItemLabelContainer___U1RPTk",
  "yU": "MobileSettingsView.module__settingsItemSpinner___U1RPTk",
  "N5": "MobileSettingsView.module__settingsItemLabel___U1RPTk",
  "o9": "MobileSettingsView.module__settingsItemArrow___U1RPTk",
  "yF": "MobileSettingsView.module__divider___U1RPTk",
  "lk": "MobileSettingsView.module__clientInfoContainer___U1RPTk",
  "rl": "MobileSettingsView.module__sourceCodeLink___U1RPTk",
  "hQ": "MobileSettingsView.module__contentContainer___U1RPTk",
  "Yd": "MobileSettingsView.module__scrollerFlex___U1RPTk",
  "rZ": "MobileSettingsView.module__profileSection___U1RPTk",
};

module.exports = exports;
